import React, { Component } from 'react';

import api from '../../../api/';

import Create from "./Create.js"
import Edit from "./Edit.js"
import Delete from "./Delete.js"
import Detail from "./Detail.js"
import Asignar from "./Asignar.js"
import Desestimar from "./Desestimar.js"
import Plan from "./Plan.js"

import ParadigmaTable from "../../../components/ParadigmaTable/"
import DateFilter from "../../../components/ParadigmaTable/DateFilter";

import 'react-datetime/css/react-datetime.css';

import dateFunctions from '../../functions/dateFunctions';

class Solicitudes extends Component {
    constructor() {
        super();
        this.state = {
            startDate: null,
            columns: [
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Nro. Presupuesto",
                    id: "cod",
                    width: 150,
                    accessor: d => (d.cod != null ? d.cod.toUpperCase() : d.codigo.toUpperCase()),
                    show: true,
                },
                {
                    Header: "Código Interno",
                    id: "codigo",
                    accessor: "codigo",
                    show: false,
                    private: true,
                },
                {
                    Header: "Fecha",
                    id: "fecha",
                    className: "text-center",
                    accessor: d => dateFunctions.parseDateTime(d.fecha),
                    show: true,
                    Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />
                },
                {
                    Header: "Título",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
                {
                    Header: "Forma de Contacto",
                    id: "strcanal",
                    accessor: d => d.strcanal,
                    show: true,
                    width: 200,
                    Filter: ({ filter, onChange }) =>
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{ width: "100%" }}
                            value={filter ? filter.value : "TODOS"}>
                            <option value="">TODOS</option>
                            <option value="Personal">Personal</option>
                            <option value="OTT">OTT</option>
                            <option value="Otros">Otros</option>
                        </select>
                },
                {
                    Header: "Empresa/Organización",
                    id: "empresa__nombre",
                    accessor: d => d.empresa__nombre,
                    show: true,
                },
                {
                    Header: "Impacta País",
                    id: "impacta_pais",
                    accessor: d => d.impacta_pais,
                    show: true,
                },
                {
                    Header: "Observaciones",
                    id: "observaciones",
                    accessor: d => d.observaciones,
                    show: true,
                },
                {
                    Header: "Usuario",
                    id: "fullname",
                    accessor: d => d.fullname,
                    show: true,
                },
                {
                    Header: "FechaEstado",
                    id: "fechaEstado",
                    className: "text-center",
                    accessor: d => dateFunctions.parseDateTime(d.fechaEstado),
                    show: false,
                    private: true
                },
                {
                    Header: "Estado",
                    id: "strestado",
                    width: 200,
                    className: "text-center",
                    Filter: ({ filter, onChange }) =>
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{ width: "100%" }}
                            value={filter ? filter.value : "TODOS"}>
                            <option value="">TODOS</option>
                            <option value="EN ANALISIS">EN ANÁLISIS</option>
                            <option value="DESESTIMADO">DESESTIMADO</option>
                            <option value="EN PLAN DE TRABAJO">EN PLAN DE TRABAJO</option>
                        </select>,
                    accessor:d => {
                        if (d.strestado == "EN ANALISIS")
                            return (
                            <div className="badge badge-warning presupuestoStateLabel">{d.strestado}
                            <br></br> <small>{dateFunctions.parseDateTime(d.fechaEstado)}</small>
                            </div>
                            );
                        else if (d.strestado == "EMAIL ENVIADO"){
                            return (
                            <div className="badge badge-success presupuestoStateLabel">{d.strestado}
                            <br></br> <small>{dateFunctions.parseDateTime(d.fechaEstado)}</small>
                            </div>
                            );
                        }
                        else if (d.strestado == "PRESUPUESTO RECHAZADO"){
                            return (
                            <div className="badge badge-danger presupuestoStateLabel">{d.strestado}
                            <br></br> <small>{dateFunctions.parseDateTime(d.fechaEstado)}</small>
                            </div>
                            );
                        }
                        else if (d.strestado == "DESESTIMADO")
                            return (
                            <div className="badge badge-danger presupuestoStateLabel">{d.strestado}
                            <br></br> <small>{dateFunctions.parseDateTime(d.fechaEstado)}</small>
                            </div>
                            );
                        else
                            return (
                            <div className="badge badge-success presupuestoStateLabel">{d.strestado}
                            <br></br> <small>{dateFunctions.parseDateTime(d.fechaEstado)}</small>
                            </div>
                            );
                    },
                    show: true,
                },
            ]
        };
    }

    render() {
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create: true,
                        permission: 'solicitudes_add',
                        component: Create,
                    },
                    {
                        detail: true,
                        permission: 'solicitudes_detail',
                        component: Detail,
                    },
                    {
                        edit: true,
                        permission: 'solicitudes_edit',
                        component: Edit,
                    },
                    {
                        edit: true,
                        permission: 'solicitudes_asignar',
                        component: Asignar,
                    },
                    {
                        edit: true,
                        permission: 'solicitudes_delete',
                        component: Delete,
                    },
                    {
                        edit: true,
                        permission: 'solicitudes_desestimar',
                        component: Desestimar,
                    },
                    {
                        edit: true,
                        permission: 'solicitudes_next',
                        component: Plan,
                    },
                ]}

                apiUrl={api.proyectos.solicitudes.list}
                columns={this.state.columns}
                exportUrl={api.proyectos.solicitudes.export}
                title={"Solicitudes"}
            />
        );
    }
}

export default Solicitudes;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento1/Solicitudes.js